<template>
    <div class="container">
        <div class="row col-md-12 align-items-center">
<!--
            <div class="row col-md-6 d-flex justify-content-center">
                <b-button @click="modificacionAutomatica" class="md-dense md-raised md-primary btn-info">{{ labels.modificacionAutomatica }}</b-button> 
            </div>
-->
            <div class="row col-md-12 align-items-center d-flex justify-content-center">
                <b-button @click="modificacionManual" class="md-dense md-raised md-primary btn-info">{{ labels.modificacionManual }}</b-button> 
            </div>
        </div>
        <div class="row col-md-12 align-items-center mt-4" v-if="showModAutomatica">
            <!-- <div class="row col-md-12 align-items-center d-flex justify-content-center">
                <h2> {{ labels.modificacionAutomatica }} </h2> 
            </div>
            <div>
                <ConsultarModificacion></ConsultarModificacion>
            </div> -->
            <ModificacionContractual :modalModContractual="showModContractual" @cierraModal="closeModal"></ModificacionContractual>
        </div>
        <div class="row col-md-12 align-items-center mt-4" v-if="showModManual">
            <div class="row col-md-12 align-items-center d-flex justify-content-center">
                <h2> {{ labels.modificacionManual }} </h2> 
            </div>
            <div>
                <ConsultarModificacion :tipoModify="tipoModificacion"></ConsultarModificacion>
            </div>
        </div>
    </div>  
</template>

<script>

import ConsultarModificacion from './ConsultarModificacion.vue'; 
import ModificacionContractual from './ModificacionContractual.vue'; 

export default {
    name : 'Modificar',
    components:{
        ConsultarModificacion,
        ModificacionContractual
    },
    data : () => ({
        showModAutomatica : false,
        showModManual : false,
        tipoModificacion : '',
        showModContractual : false
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Modificación',
                    modificacionAutomatica : 'Cambio Contractual',
                    modificacionManual : 'Cambio Manual'
                }
            }else{
                return {
                    title : 'Modification',
                    modificacionAutomatica : 'Contractual change',
                    modificacionManual : 'Manual modification'
                }                
            }
        }
    },
    methods:{
        closeModal(val){
            this.showModContractual = val 
        },
        modificacionAutomatica(){
            this.showModAutomatica = true 
            this.showModManual = false 
            this.tipoModificacion = 'Automatica' 

            this.showModContractual = true 
        },
        modificacionManual(){
            this.showModManual = true 
            this.showModAutomatica = false 
            this.tipoModificacion = 'Manual' 
        }
    }
}
</script>
